import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationServiceListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setServiceList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useVeticServiceListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  //
  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isServiceListLoadingInProgess",
        status: true,
      }),
    );
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(`${CONFIGURATION_APIS?.SERVICE_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationServiceListResponse>) => {
          if (res.data.status === true) {
            dispatch(setServiceList({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isServiceListLoadingInProgess",
                status: false,
              }),
            );
          } else {
            dispatch(setServiceList({ data: [] }));
            dispatch(
              setLoading({
                key: "isServiceListLoadingInProgess",
                status: false,
              }),
            );
          }
        })
        .catch((e: AxiosError) => {
          dispatch(setServiceList({ data: [] }));
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      dispatch(setServiceList({ data: [] }));
      dispatch(
        setLoading({
          key: "isServiceListLoadingInProgess",
          status: false,
        }),
      );
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return { execute };
};
